import { render, staticRenderFns } from "./mo-input-wrapper.html?vue&type=template&id=721e6735&external"
import script from "./mo-input-wrapper.ts?vue&type=script&lang=ts&external"
export * from "./mo-input-wrapper.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/agent/_work/5/s/Be.Vlaanderen.Mo.Vue/ClientApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('721e6735')) {
      api.createRecord('721e6735', component.options)
    } else {
      api.reload('721e6735', component.options)
    }
    module.hot.accept("./mo-input-wrapper.html?vue&type=template&id=721e6735&external", function () {
      api.rerender('721e6735', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/shared/mo-input-wrapper/mo-input-wrapper.vue"
export default component.exports